exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".zbb_container{width:100%;height:100%}.zbb_box-card .el-card__body{padding:.5rem .5rem .5rem .5rem!important}#noPadding .el-table td>.cell,#noPadding .el-table th>.cell{padding-right:0}#noPadding .el-table__header,.el-table__body,.el-table__footer{border-collapse:collapse}", ""]);

// exports
